// extracted by mini-css-extract-plugin
export var legendIndicator = "_a9-1";
export var legendRight = "_a9-0";